import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";

import { PATH_HOME } from "@configs";
import { setInviteId } from "@redux";
import CacheStore from "@Rocket-Innovation/components/store/CacheStore";

export const PageInviteFriend = () => {
    const { id } = useParams<{ id: string }>();
    const dispatch = useDispatch();
    const history = useHistory();
    useEffect(() => {
        if (id) {
            dispatch(setInviteId(id));

            //Update in Rocket-Innovation's components
            CacheStore.setState({
                appendFields: {
                    ...CacheStore.getState().appendFields,
                    inviteId: id,
                },
            });

            history.push(PATH_HOME);
        }
    }, [id]);
    return <></>;
};
